export { default as acquisition } from './reducer';
export * from './state.interface';
export * from './actions';
export * from './selectors';
export * from './actionPayload.interfaces';
